export default "/template/resource//static/media/img_hulian@2x.8313786a.png";